(function ($) {
  $(document).ready(function ($) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;
  });
})(jQuery);
